const Dashboard = {
    dashboard: () => "store/admin/dashboard",
    inventoryDetails: () => "store/inventory-details",
    orderDetails: () => "store/sales-orders/last-12-months",
    accountSearch: () => "store/report/account/search",
    glAccountReport: () => "store/report/gl-account",
}

export default Dashboard
